module.exports = __webpack_public_path__ + "img/banner-15.402f90ac.jpg";